import Factory from '../factory';

const schema = Factory.schema('programmes');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('title').setType(String).setValue('Title');
attributes.prop('items').setType(Array);

export default schema;
